import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";

type ScreenModeContextType = {
  isMobile: boolean;
  isDesktop: boolean;
};

const ScreenModeContext = createContext<ScreenModeContextType | undefined>(
  undefined
);

const MOBILE_BREAKPOINT = 768;

export function ScreenModeProvider({ children }: { children: ReactNode }) {
  const [isMobile, setIsMobile] = useState(() =>
    window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(max-width: ${MOBILE_BREAKPOINT - 1}px)`
    );

    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return (
    <ScreenModeContext.Provider
      value={{
        isMobile,
        isDesktop: !isMobile,
      }}
    >
      {children}
    </ScreenModeContext.Provider>
  );
}

export function useScreenMode() {
  const context = useContext(ScreenModeContext);

  if (!context) {
    throw new Error(
      "useScreenMode must be used inside a ScreenModeProvider"
    );
  }

  return context;
}